import { getAppEndpointVersion } from 'helpers'
import axios from './axiosInstance'
import constants from '../constants'

export default function init() {
  console.log('webhoooks init')
}

export async function list(app, apiHost, pageNo = 1, searchText = '') {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/webhooks?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function add(post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/webhooks`
  return axios
    .post(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function get(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/webhooks/${id}`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function update(id, post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/webhooks/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function del(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/webhooks/${id}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getTriggersByID(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/webhooks/${id}/triggers`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function newAddTriggers(id, post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/webhooks/${id}/triggers`
  return axios
    .post(
      `${URL}`,
      {
        triggerIds: post,
      },
      {
        headers: {
          appId: app.id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function newDelTriggers(id, post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/webhooks/${id}/triggers`
  return axios
    .delete(
      `${URL}`,

      {
        headers: {
          appId: app.id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        data: {
          triggerIds: post,
        },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}
